document.addEventListener('DOMContentLoaded', () => {
    const filter = document.getElementById('blog-filter');
    const btn = document.getElementById('blog-load-more');
    const content = document.getElementById('blog-load-more-content');

    if( !filter && !btn && !content ) return false;

    const items = filter.querySelectorAll('label');

    if( !items ) return false;

    items.forEach( item => {
        item.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();

            item.classList.add('active');
            btn.setAttribute('data-category', item.id.replace('category-', ''));
            
            window.BlogRequest(btn, content, true);
            
            items.forEach( inactive => {
                if( item.id !== inactive.id ) {
                    inactive.classList.remove('active');
                }
            });
        });
    });
});